import 'spin.js/spin.css';
import { Spinner } from 'spin.js';
export function createSpinner(options) {
    const defaults = {
        lines: 9, // The number of lines to draw
        length: 0, // The length of each line
        width: 7, // The line thickness
        radius: 14, // The radius of the inner circle
        corners: 1, // Corner roundness (0..1)
        rotate: 30, // The rotation offset
        direction: 1, // 1: clockwise, -1: counterclockwise
        color: '#1ca1e2', // #rgb or #rrggbb
        speed: 0.7, // Rounds per second
        trail: 60, // Afterglow percentage
        shadow: false, // Whether to render a shadow
        hwaccel: false, // Whether to use hardware acceleration
        zIndex: 2e9, // The z-index (defaults to 2000000000)
    };
    return new Spinner({ ...defaults, ...options });
}
